export type AdminMenuItem = {
  label: string;
  path: string;
  icon: string;
};

export const adminMenuItems: AdminMenuItem[] = [
  { label: 'Finance Command Center', path: '/admin/control-tower', icon: '◎' },
  { label: 'Enterprise Overview', path: '/admin/dashboard', icon: '▦' },
  { label: 'Expenses', path: '/admin/expenses', icon: '▤' },
  { label: 'Trips', path: '/admin/trips', icon: '✈' },
  { label: 'Team Approvals', path: '/admin/team-approvals', icon: '☑' },
  { label: 'Analytics', path: '/admin/analytics', icon: '⌁' },
  { label: 'Reimbursements', path: '/admin/reimbursements', icon: '₹' },
  { label: 'Settings', path: '/admin/settings', icon: '⚙' },
];
